import styled from 'styled-components'

/**
 * Altura maxima da lista do Select dentro do compositor.
 *
 * Exportada porque precisa ser a MESMA em dois lugares: o `maxHeight` passado ao
 * Select e o espaco que o formulario reserva para a lista aberta. Divergir faria
 * a lista voltar a ser cortada (reserva menor) ou abrir um vao morto no popover
 * (reserva maior).
 */
export const ALTURA_LISTA_SELECT = 180


export const ModalWrapper = styled.div`
    display: grid;
    grid-template-rows: auto 1fr auto;
    height: 480px;
    max-height: 70vh;
    box-sizing: border-box;
    overflow: hidden;

    /* ---------------------------------------------------------------------- */
    /*                                 HEADER                                 */
    /* ---------------------------------------------------------------------- */
    header.StatusTimeLine__header {
        display: flex;
        flex-direction: column;
        border-bottom: thin solid var(--border-color);
        box-sizing: border-box;
        padding-bottom: 12px;

        div.StatusTimeLine__header__linha {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        }

        /* O chip do status atual usa a Tag do antd: aqui só o espaçamento. */
        span.ant-tag {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            margin: 0;
            width: fit-content;
            font-size: 12.5px;
            font-weight: 500;
            margin-top: -5px;
        }
    }

    /* ---------------------------------------------------------------------- */
    /*                               HISTÓRICO                                */
    /* ---------------------------------------------------------------------- */
    div.StatusTimeLine__historico {
        display: flex;
        flex-direction: column;
        gap: 3px;
        padding-top: 12px;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;

        /* Sem itens (ou carregando) o conteúdo fica centralizado na faixa. */
        &:is([data-vazio='true']) {
            justify-content: center;
        }
    }

    /* ---------------------------------------------------------------------- */
    /*                             ITEM DA TIMELINE                           */
    /* ---------------------------------------------------------------------- */
    div.StatusTimeLine__item {
        display: flex;
        gap: 10px;
        box-sizing: border-box;
        border-radius: 6px;
        padding: 2px;
        transition: background-color 0.3s ease;

        /* Variante ghost: pré-visualização do status escolhido. */
        &:is([data-ghost='true']) {
            border: 1px dashed var(--border-color);
            padding: 6px;
            margin-top: 4px;
        }

        div.StatusTimeLine__item__marcador {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            flex-shrink: 0;

            span.StatusTimeLine__item__marcador__icone {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                box-sizing: border-box;
            }

            /* A linha some no último item: antes sobrava um traço solto no fim. */
            div.StatusTimeLine__item__marcador__linha {
                width: 1px;
                flex: 1;
                min-height: 22px;
                background-color: var(--border-color);
            }
        }

        div.StatusTimeLine__item__conteudo {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding-top: 2px;
            min-width: 0;

            h3 {
                padding: 0;
                margin: 0;
                font-size: 15px;
                font-weight: 600;
                line-height: 1.3;
            }

            span {
                padding: 0;
                margin: 0;
                font-size: 13px;
                font-weight: 400;
                color: var(--text-color);
            }

            p {
                padding: 0;
                margin: 0;
                font-size: 12px;
                font-weight: 300;
                color: var(--text-color-light);
            }
        }

        /* Destaque do último item = status atual da OS. */
        &:is([data-atual='true']) div.StatusTimeLine__item__conteudo h3 {
            font-weight: 700;
        }
    }

    /* ---------------------------------------------------------------------- */
    /*                          RODAPE (GATILHO)                              */
    /* ---------------------------------------------------------------------- */
    /* Guarda apenas o botao "Alterar status": o formulario vive no
       ModalPopOver, que renderiza por portal fora desta arvore. */
    footer.StatusTimeLine__compositor {
        display: flex;
        padding: 12px 14px;
        border-top: thin solid var(--border-color);
        background: #fff;
        box-sizing: border-box;
    }
`

/**
 * Formulario de alteracao de status, dentro do corpo do ModalPopOver.
 *
 * Exportado separado do `ModalWrapper` de proposito: o popover usa
 * `createPortal` para `#portal`, logo o formulario NAO e descendente do modal e
 * nao seria alcancado por um seletor aninhado ali.
 */
export const FormAlterarStatus = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    box-sizing: border-box;

    /* A lista do Select e "position: absolute" DENTRO do proprio wrapper (nao vai
       para portal), e o corpo do ModalPopOver tem "overflow-y: auto" enquanto o
       container tem "overflow: hidden" — entao a lista aberta era recortada.

       Como o ModalPopOver e compartilhado (e nao deve ser alterado por este
       modulo), a saida e o formulario RESERVAR a altura da lista enquanto ela
       esta aberta: o corpo do popover cresce, a lista passa a caber na area
       visivel e nada e cortado.

       O valor acompanha o "maxHeight" passado ao Select (ALTURA_LISTA_SELECT)
       mais a folga do deslocamento da lista ("top: 57px" a partir do campo). */
    &:is([data-select-aberto='true']) {
        padding-bottom: ${ALTURA_LISTA_SELECT + 20}px;
    }
`
